import { useQuery } from 'react-query';

import { getV2ApiCompanyIdInternationalTransfersKycStatus } from 'src/client/spendesk-api';

export const useGetWiseKycStatus = ({
  companyId,
  enabled = true,
  refetchInterval,
}: {
  companyId: string;
  enabled: boolean;
  refetchInterval?: number | undefined;
}) => {
  return useQuery(
    ['internationalTransfers', 'kycStatus', companyId],
    async () => {
      const response = await getV2ApiCompanyIdInternationalTransfersKycStatus({
        path: { companyId },
      });

      if (response.statusCode !== 200) {
        throw new Error('Failed to get KYC status');
      }

      return response.body.data.kycStatus;
    },
    {
      retry: false,
      refetchOnWindowFocus: true,
      enabled,
      refetchInterval: (data) => {
        if (data === 'NEW') {
          return refetchInterval ?? false;
        }

        return false;
      },
      staleTime: 2 * 60 * 1000,
      cacheTime: 2 * 60 * 1000,
    },
  );
};
